import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export const NAME_VALIDATION_ERRORS = {
  NUMBER_IN_STRING: 'numberInString',
};

export function nameValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return null;
    }

    return isNumberInString(value) ? {[NAME_VALIDATION_ERRORS.NUMBER_IN_STRING]: true} : null;
  };
}

function isNumberInString(value: string): boolean {
  return /\d/.test(value);
}
